const Loading = (): JSX.Element => {
  return (
    <div className="my-auto animate-pulse">
      <div className="mb-2 h-8 w-3/4 rounded-lg bg-gray-200" />
      <ul>
        <li className="mb-1.5 flex items-center gap-2">
          <div className="size-6 rounded-full bg-gray-200" />
          <div className="h-6 w-1/2 rounded-lg bg-gray-200" />
        </li>
        <li className="mb-1.5 flex items-center gap-2">
          <div className="size-6 rounded-full bg-gray-200" />
          <div className="h-6 w-1/3 rounded-lg bg-gray-200" />
        </li>
        <li className="flex items-center gap-2">
          <div className="size-6 rounded-full bg-gray-200" />
          <div className="h-6 w-2/5 rounded-lg bg-gray-200" />
        </li>
      </ul>
    </div>
  )
}

export default Loading
